import { render, staticRenderFns } from "./WedOrderCancel.vue?vue&type=template&id=0aac78e0&scoped=true"
import script from "./WedOrderCancel.vue?vue&type=script&lang=js"
export * from "./WedOrderCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac78e0",
  null
  
)

export default component.exports